import React from "react";
import { Button, Image } from "react-bootstrap";
import Switch from "react-switch";

export const UomTableBody = (props) => {
  return (
    <React.Fragment>
      <tr
        className="bg-white pl-3 pr-2 py-2 mb-3 f12-500"
        style={{ boxShadow: "0px 3px 6px #6E6E6E21" }}
      >
        <td style={{ width: "10%" }}>{props.serialNo}</td>
        <td style={{ width: "15%" }}>{props.unitName}</td>
        <td style={{ width: "15%" }}>{props.shortCode}</td>
        <td style={{ width: "15%" }}>{props.uomSystem}</td>
        <td style={{ width: "17%" }}>{props.majorClassification}</td>
        <td style={{ width: "18%" }}>
          <Switch
            // onClick={(e) => {
            //   if (!e) var e = window.event;
            //   e.cancelBubble = true;
            //   if (e.stopPropagation) e.stopPropagation();
            // }}
            disabled={true}
            onChange={props.onChangeStatus}
            checked={props.status === "ACTIVE" ? true : false}
            offColor="#EEEEEE"
            onColor="#EEEEEE"
            offHandleColor="#212121"
            onHandleColor="#59F832"
            handleDiameter={24}
            uncheckedIcon={false}
            checkedIcon={false}
            height={15}
            width={41}
            boxShadow="-2px 0px 5px #0000003B"
            activeBoxShadow="-2px 0px 5px #0000003B"
            id="material-switch"
          />
        </td>
        <td style={{ width: "10%" }}>
          <div className="f12-400 d-flex">
            <Button
              variant="link"
              className="enIconBtn mr-3"
              onClick={props.onClickDelete}
            >
              <Image
                src={require("../../../../../assets/images/UserManagement/Delete.svg")}
                alt="Delete"
                title="Delete"
                fluid
              />
            </Button>
            <Button
              variant="link"
              className="enIconBtn mr-3"
              onClick={props.onClickEdit}
            >
              <Image
                src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </Button>
          </div>
        </td>
      </tr>
    </React.Fragment>
  );
};
